import { call, put, select, takeEvery } from 'redux-saga/effects';
import {
  DESCONCILIAR_TRANSACAO,
  DESCONCILIAR_TRANSACAO_PENDING,
  DESCONCILIAR_TRANSACAO_SUCCESS,
  DESCONCILIAR_TRANSACAO_FAILURE,
  NEW_FILTER_CONCILIACAO_BANCARIA,
  BUSCAR_RESUMO_CONCILIACAO
} from '../actionTypes';
import { conciliacaoBancariaService } from '../service';
import { AlertError, AlertSuccess } from '@components/common/AlertToast';

export function* desconciliarTransacao(action) {
  try {
    yield put({ type: DESCONCILIAR_TRANSACAO_PENDING });

    const { lancamentoOFXId, tipoDesconciliacao, observacao } = action;

    // Validações básicas
    if (!lancamentoOFXId) {
      throw new Error('lancamentoOFXId é obrigatório');
    }

    if (!tipoDesconciliacao) {
      throw new Error('tipoDesconciliacao é obrigatório');
    }

    const payload = {
      lancamentoOFXId,
      tipoDesconciliacao,
      observacao: observacao || ''
    };

    // Chamada para API
    const response = yield call(conciliacaoBancariaService.desconciliar, payload);

    yield put({
      type: DESCONCILIAR_TRANSACAO_SUCCESS,
      data: response.data
    });

    // Mostrar mensagem de sucesso
    AlertSuccess('Transação desconciliada com sucesso!');

    // Recarregar dados da listagem após sucesso, preservando o filtro de tipo (entradas/saídas)
    const currentFilter = yield select(state => state.entities.conciliacaoBancariaReducer.filter);
    yield put({
      type: NEW_FILTER_CONCILIACAO_BANCARIA,
      newFilter: true, // Usar true para preservar tipoTransacao
      args: {
        ...currentFilter,
        page: currentFilter.page || 0 // Manter na mesma página se possível
      }
    });

    // Atualizar resumo da conciliação
    const contaBancoId = currentFilter.contaBanco?.id;
    if (contaBancoId) {
      yield put({
        type: BUSCAR_RESUMO_CONCILIACAO,
        contaBancoId
      });
    }

  } catch (error) {
    yield put({
      type: DESCONCILIAR_TRANSACAO_FAILURE,
      error: error.message || 'Erro ao desconciliar Transação'
    });

    // Mostrar mensagem de erro
    const errorMessage = error.response?.data?.message || error.message || 'Erro ao desconciliar Transação';
    AlertError(errorMessage);
  }
}

export function* watchDesconciliarTransacao() {
  yield takeEvery(DESCONCILIAR_TRANSACAO, desconciliarTransacao);
}